import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppLayout } from './layout.style';
import { Navbar } from '../../modules/app';
import ChatBot from '../../modules/pages/chatBot/chatBot';
import { useAuth } from '../../hooks/useAuth';
// import { UrbanCompassLogoBlack } from '../../icons';
import { IntlMessages } from '../../helper/langHelper';
import RouteTour from '../tour/RouteTour';
// import TourRestartButton from '../tour/TourRestartButton';
import MapperNavbar from '../../modules/app/mapperNavbar/mapperNavbar';
import useMediaQuery from '../../hooks/useMediaQuery';
// import { RefreshWarningPopUp } from '../globalRefreshWarningComp';

const RootLayout = () => {
  const [loader, setLoader] = useState(false);
  const userRole = localStorage.getItem('userRole');
  const location = useLocation();
  const isMapView =
    location.pathname === '/mapView' ||
    // location.pathname === '/' ||
    location.pathname === '/generateQuestion' ||
    location.pathname === '/preLodgementQaChat';
  const isOnlyMapView =
    location.pathname === '/mapView' ||
    location.pathname === '/generateQuestion' ||
    location.pathname === '/preLodgementQaChat';
  const { session } = useAuth();

  const isLoggedIn = Boolean(session?.token);
  const isMobile = useMediaQuery('(max-width: 480px)');

  return (
    <>
      {/* <RefreshWarningPopUp /> */}
      <AppLayout>
        {userRole === 'user' && <Navbar />}
        {userRole === 'mapper' && <MapperNavbar />}

        {/* ...joy tour... */}
        <RouteTour />
        {/* <TourRestartButton className="tour-restart-btn" /> */}
        {/* ......... */}

        <Outlet context={[loader, setLoader]} />
        <Loading visible={loader} />
        {isLoggedIn && !isMapView && userRole !== 'admin' && userRole !== 'mapper' && !isMobile ? (
          <ChatBot />
        ) : null}
        {/* Urban Compass Footer */}
        {!isOnlyMapView && userRole !== 'admin' && userRole !== 'mapper' && !isMobile && (
          <div
            style={{
              position: 'fixed',
              bottom: '10px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '8px',
              fontSize: '12px',
              color: 'black',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              padding: '10px 16px',
              borderRadius: '20px',
              zIndex: 1002,
              border: '1px solid #4167B2',
            }}
          >
            <span>
              <IntlMessages id="powered.by" />
            </span>
            {/* <UrbanCompassLogoBlack style={{ width: '34px', height: '34px' }} /> */}
          </div>
        )}
      </AppLayout>
    </>
  );
};

export default RootLayout;

const Loading = ({ visible }) => {
  return (
    <div
      style={{
        display: visible ? 'block' : 'none',
        position: 'fixed',
        backgroundColor: 'red',
        height: '100vh',
        width: '100vw',
        zIndex: 400,
        padding: '50vh 50vw',
      }}
    >
      Loading....
    </div>
  );
};
